import React from "react";

const ProjectPage = () => {
  const videoId = "odKwT5wOi4U";

  const credits = [
    { role: "Director / Cinematographer / Editor", name: "Sylvester P. Lukasiewicz, SPL Films LLC" },
    { role: "Sound Mixer", name: "Robert Kahn, Mixology Post LLC" },
    { role: "Color Correction & Grading", name: "Luis Otero, CSI, Digital Emulsion LLC" },
  ];

  return (
    <div className="max-w-5xl mx-auto px-6 sm:px-8 py-12 md:py-16 text-white">
      
      {/* Hero Header & Video */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center mb-12">
        <div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight mb-4">
            Back to One - Return to Ground Zero
          </h1>
          <div className="text-base sm:text-lg font-medium tracking-wide text-gray-300 space-y-1">
            <p>Documentary Short</p>
            <p>United States | 26 minutes</p>
            <p>English | English subtitles</p>
          </div>
        </div>

        <div className="relative pb-[56.25%] h-0 shadow-2xl rounded-lg overflow-hidden border border-gray-700 bg-black">
          <iframe
            className="absolute top-0 left-0 w-full h-full"
            src={`https://www.youtube.com/embed/${videoId}`}
            title="Back to One"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>

      {/* Availability & Broadcast Information */}
      <section className="bg-gray-900/60 border border-gray-700/80 rounded-xl p-6 sm:p-8 mb-12 shadow-xl backdrop-blur-sm space-y-6">
        
        {/* Current Availability */}
        <div>
          <h2 className="text-base sm:text-lg font-bold tracking-wider text-sky-400 uppercase mb-2 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-sky-400"></span>
            Current Availability
          </h2>
          <p className="text-gray-200 text-base pl-4">
            Select domestic and international film festivals
          </p>
        </div>

        {/* Upcoming Broadcast Availability */}
        <div className="pt-6 border-t border-gray-800/80">
          <h2 className="text-base sm:text-lg font-bold tracking-wider text-sky-400 uppercase mb-2 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-sky-400"></span>
            Upcoming Broadcast Availability
          </h2>
          <p className="text-gray-200 text-base pl-4">
            PBS member stations, state and regional public TV networks - January 2027 (via NETA, distributor)
          </p>
        </div>

        {/* Upcoming Streaming Availability */}
        <div className="pt-6 border-t border-gray-800/80">
          <h2 className="text-base sm:text-lg font-bold tracking-wider text-sky-400 uppercase mb-2 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-sky-400"></span>
            Upcoming Streaming Availability
          </h2>
          <p className="text-gray-200 text-base pl-4">
            PBS App - January 2027 (via NETA, distributor)
          </p>
        </div>

        {/* Past 2026 Broadcast History */}
        <div className="pt-6 border-t border-gray-800/80">
          <h2 className="text-base sm:text-lg font-bold tracking-wider text-sky-400 uppercase mb-3 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-sky-400"></span>
            Past 2026 Broadcast History
          </h2>
          <div className="pl-4 space-y-2 text-base text-gray-200">
            <p>September 6, 8, 11 - <span className="font-semibold text-white bg-gray-800 px-2 py-0.5 rounded text-sm ml-1">NYC Life</span></p>
            <p>September 7-13 - <span className="font-semibold text-white bg-gray-800 px-2 py-0.5 rounded text-sm ml-1">CUNY TV</span></p>
            <p>September 11 - <span className="font-semibold text-white bg-gray-800 px-2 py-0.5 rounded text-sm ml-1">TVN24 BiS</span></p>
            <p>September 11 - <span className="font-semibold text-white bg-gray-800 px-2 py-0.5 rounded text-sm ml-1">TVN24+</span></p>
          </div>
        </div>
      </section>

      <hr className="border-gray-600 border-t my-10" />

      {/* Synopsis */}
      <section className="space-y-6 text-lg text-gray-200">
        <p className="font-bold text-xl leading-relaxed text-white">
          An intimate documentary following a former Windows on the World employee and 9/11 survivor as he returns to the rebuilt World Trade Center site for the first time in 24 years, honoring lost colleagues and reflecting on memory, resilience, and healing. 
        </p>
        <p>
          In this moving documentary, former Windows on the World banquet captain and manager Stephen Lindsey reflects on the events of September 11, 2001, and the lasting impact of that day on his life and community. Through personal memories and a return to the rebuilt World Trade Center site, Stephen recounts witnessing the attacks, coping with the loss of colleagues and friends, and finding ways to honor those who never came home.
        </p>
        <p>
          As he walks through the 9/11 Memorial, The Oculus, and the Winter Garden, Stephen shares stories of camaraderie, everyday joys, and small acts of kindness that defined the close-knit community he once knew. Juxtaposing the beauty of the reconstructed site with the profound absence left behind, the film explores themes of grief, memory, resilience, and healing. Both a deeply personal elegy and a tribute to collective remembrance, it celebrates the enduring human spirit in the face of unimaginable loss.
        </p>
      </section>

      <hr className="border-gray-600 border-t my-10" />

      {/* Credits */}
      <section>
        <h2 className="text-2xl font-extrabold tracking-widest mb-8 text-white">CREDITS</h2>
        <div className="space-y-6">
          {credits.map((credit, index) => (
            <div key={index}>
              <h3 className="font-bold text-lg text-white">{credit.role}</h3>
              <p className="text-base text-gray-300">{credit.name}</p>
            </div>
          ))}
        </div>
      </section>

    </div>
  );
};

export { ProjectPage };